import Api from '../services/Api';

export async function loadComponentsMetadata(componentId) {
  const response = await Api.get(`/instances/building-components/${componentId}`);
  return {
    elements: response.data.elements,
    buildings: response.data.component_buildings,
    characteristics: response.data.characteristics,
    contexts: response.data.contexts,
  };
}

export async function loadElementsMetadata(elementId) {
  const response = await Api.get(`/instances/building-elements/${elementId}`);
  return {
    components: response.data.components,
    characteristics: response.data.characteristics,
    contexts: response.data.contexts,
  };
}

export async function loadProductsMetadata(productId) {
  const response = await Api.get(`/instances/building-products/${productId}`);
  return {
    characteristics: response.data.characteristics,
    buildings: response.data.buildings,
    contexts: response.data.contexts,
  };
}

export async function loadContextsMetadata(contextId) {
  const response = await Api.get(`/instances/building-contexts/${contextId}`);
  return {
    buildings: response.data.buildings,
  };
}

export async function loadCharacteristicMetadata(contextId) {
  const response = await Api.get(`/instances/building-characteristics/${contextId}`);
  return {
    buildings: response.data.buildings,
  };
}

export async function loadBuildingsMetadata(buildingId) {
  const buildingResponse = await Api.get(`/instances/buildings/${buildingId}`);
  return {
    components: buildingResponse.data.components,
    elements: buildingResponse.data.elements,
    contexts: buildingResponse.data.contexts,
    products: buildingResponse.data.products,
    characteristics: buildingResponse.data.characteristics,
    citation: buildingResponse.data.citation,
  };
}
